import styled, { injectGlobal } from 'styled-components';
import * as fonts from 'view/styles/fonts';
import * as grid from 'view/styles/grid';
import { portalsCardTitleStyle } from 'view/styles/help-center';
import * as mixins from 'view/styles/mixins';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { TooltipPrimitive } from '@atlaskit/tooltip';

// eslint-disable-next-line rulesdir/no-styled-export
export const FeaturedPortalsWrapper = styled.section`
    h2 {
        ${fonts.h300}
        text-transform: uppercase;
        margin-top: ${token('space.0', '0px')};
        margin-bottom: ${token('space.100', '8px')};
        ${portalsCardTitleStyle}
    }

    margin-top: ${token('space.200', '16px')};
    border-bottom: ${grid.multiple(0.25).px} solid ${token('color.border', colors.N30A)};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const FeaturedPortalTitle = styled.h2`
    ${fonts.h300}
    text-transform: uppercase;
    margin-top: ${token('space.0', '0px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const TooltipWrapper = styled.div`
    display: flex;
    align-items: flex-start;
    padding: ${token('space.100', '8px')};
    width: ${grid.multiple(11).px};
    margin-left: ${grid.multiple(-1).px};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const StyledToolTipPrimitive = styled(TooltipPrimitive)`
    ${mixins.toolTipPrimitiveStyle}
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const InfoIconWrapper = styled.div`
    margin: -${grid.multiple(0.5).px} 0 -${grid.multiple(0.5).px} ${token('space.050', '4px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export
export const SuccessFlagActionWrapper = styled.div`
    margin-left: -${grid.multiple(1.5).px};
`;

injectGlobal`
  .not-selectable {
    user-select: none;
  }
`;
